import React from 'react';
import { useJobs } from '../hooks/useJobs';
import { JobsPage } from './Progression/JobsPage';

/** The `jobs` window body: the server's job for this character, on the Tome page. */
export const JobsContent: React.FC = () => <JobsPage jobs={useJobs()} />;
